import React from 'react';
import { motion } from 'framer-motion';
import { ImageOff, Lock, AlertCircle } from 'lucide-react';
const scenarios = [{
  icon: <ImageOff className="w-12 h-12 text-gold" data-id="element-124" />,
  title: 'Perder las fotos de toda una vida',
  description: 'Si tu teléfono se daña o se pierde hoy, ¿estás segura de que tus hijos podrían recuperar esas fotos irremplazables de los nietos?'
}, {
  icon: <AlertCircle className="w-12 h-12 text-gold" data-id="element-125" />,
  title: 'Cuentas bloqueadas en emergencias',
  description: 'En caso de un imprevisto médico, tu familia necesita acceso rápido a información importante, pero no saben por dónde empezar.'
}, {
  icon: <Lock className="w-12 h-12 text-gold" data-id="element-126" />,
  title: 'El estrés de las contraseñas olvidadas',
  description: 'La frustración constante de no recordar la clave correcta y el miedo a quedar bloqueada de tus propias cuentas bancarias o redes sociales.'
}];
export function PainSection() {
  return <section className="py-20 px-6 md:px-12 lg:px-24 bg-white" data-id="element-127">
      <div className="max-w-5xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-129">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-130">
            La tecnología avanza rápido, pero tus recuerdos no deberían quedarse
            atrás
          </h2>
          <p className="text-xl text-navy-light max-w-3xl mx-auto" data-id="element-131">
            Muchas mujeres de nuestra generación sienten una preocupación
            silenciosa. Sabemos que nuestra vida está cada vez más en internet,
            pero nadie nos enseñó cómo organizarla de forma segura.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-132">
          {scenarios.map((scenario, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-cream p-8 rounded-2xl border border-cream-dark shadow-sm" data-id="element-133">
              <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-134">
                {scenario.icon}
              </div>
              <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-135">
                {scenario.title}
              </h3>
              <p className="text-lg text-navy-light leading-relaxed" data-id="element-136">
                {scenario.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}